import React, { useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Grid, InputAdornment, TextField } from '@mui/material';
const FilterComponent = (props) => {
  const { onFilter, placeHolder } = props;
  const [typingTimeout, setTypingTimeout] = useState(0);

  const sendToParent = (searchText) => {
    onFilter(searchText);
  };

  const onChangeName = (event) => {
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    setTypingTimeout(setTimeout(() => sendToParent(event.target.value), 500));
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <Box sx={{ marginTop: '20px' }}>
            <TextField
              id="standard-basic"
              type="search"
              placeholder={
                placeHolder?.length ? placeHolder : 'Search by title'
              }
              variant="standard"
              onChange={onChangeName}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />{' '}
                  </InputAdornment>
                ),
              }}
            />            
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default FilterComponent;
